// extracted by mini-css-extract-plugin
export var videoHero = "_dg-4";
export var videoHeroImage = "_dg-5";
export var videoHeroOverlay = "_dg-6";
export var videoHeroSubtitle = "_dg-8";
export var videoHeroText = "_dg-7";
export var videoLauncher = "_dg-0";
export var videoLauncherIcon = "_dg-1";
export var videoLauncherSubtitle = "_dg-3";
export var videoLauncherTitle = "_dg-2";
export var videoPlayer = "_dg-a";
export var videoPlayerWrap = "_dg-9";